import React from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ContactModal from "../ContactModal";

function CommentMarcheIncluvia() {
    return (
            <>
                <h2 className="libre-title mb-3">Comment <span>ça marche ?</span></h2>


                <div className="text-left pb-1 pt-2">
                    <div className="text">
                        <strong>
                            Vous avez des questions en tant que collaborateur ou manager, afin de vous renseigner
                            sur le handicap au travail et les maladies chroniques, connaître
                            vos droits et être accompagné·e dans vos démarches ?
                        </strong>
                        <br/>
                        <br/>
                        Consultez cet espace <b>Hotline Handicap pour vous informer</b>, accéder à des <b>ressources utiles</b> et
                        à une <b>FAQ</b> (foire aux questions avec des réponses aux questions fréquentes)
                        pour obtenir de premiers éléments de réponse, et en cas de besoin, <b>réserver votre
                        rendez-vous avec un expert chez notre partenaire Talents Handicap</b>,
                        pour échanger de <b>manière confidentielle<sup>*</sup></b>, par visio,
                        téléphone ou chat, et recevoir des conseils personnalisés
                        et des réponses concrètes à vos questions.

                        <br/>
                        <br/>

                        <strong>Pour réserver votre rendez-vous, choisissez directement :</strong>
                        <br/>
                        <br/>
                        <ul>
                            <li>🗓️ le créneau horaire qui vous convient, parmi les dates proposées <b>(permanence chaque mercredi après-midi entre 14h et 17h)</b></li>
                            <li>💬 le mode de communication que vous préférez : <b>visio/chat  ou téléphone</b></li>
                        </ul>

                    </div>

                </div>
                <div className="text-center pb-2 page-lahalle">
                    <ContactModal textButton="Réserver mon RDV"
                                  showText={false}
                                  small="small"
                                  linkPageContact={false}
                                  iframe={true}
                                  couleur={false}
                                  page="incluvia"
                    />
                </div>
                <div className="text-center pb-1 pt-2 small mt-3">
                    <strong>*Votre anonymat est notre priorité. Vos coordonnées ne seront jamais partagées.</strong>
                </div>
            </>
    );
}

export default CommentMarcheIncluvia;
